import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { profileUpdate } from 'src/redux/reducer/profileUpdateSlice';
import { ApiGet } from 'src/services/http-service';

const Plansuccess = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const callupdateuser = (id: any) => {
    ApiGet('/subscriptionupdate/' + id)
      .then((res: any) => {
       
        let local = JSON.parse(localStorage.getItem('logindata') || '');
        let data = {
          ...local,
          activeplan: res.data.extra.activeplan,
          planexpiry: res.data.extra.planexpiry
        };
        localStorage.setItem('logindata', JSON.stringify(data));
        localStorage.setItem(
          'planexpire',
          JSON.stringify(res.data.extra.planexpiry)
        );
        dispatch(profileUpdate(data));
      })
      .catch((err: any) => {
        window.console.log(err);
      });
  };
  const callupdateuserpurchase = (id: any) => {
   
    ApiGet('/purchaseupdate/' + id)
      .then((res: any) => {
        console.log('res', res);
      })
      .catch((err: any) => {
        window.console.log(err);
      });
  };
  useEffect(() => {
    const queryString: any = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    if (searchParams.getAll('session_id').length > 0) {
      callupdateuser(searchParams.getAll('session_id')[0]);
    } else if (searchParams.getAll('purchase_id').length > 0) {
      callupdateuserpurchase(searchParams.getAll('purchase_id')[0]);
    }
  }, []);

  return (
    <div className="container section-padding text-center" style={{ minHeight: '50vh' }}>
      <img
        src={'/Image/success.png'}
        alt="Payment successful"
        style={{ maxWidth: '480px', width: '100%', marginBottom: '24px' }}
      />
      <h1 className="gradient-text" style={{ fontSize: '32px', marginBottom: '12px' }}>
        Payment successful
      </h1>
      <p style={{ fontSize: '16px', marginBottom: '24px' }}>
        Thank you for your purchase. Your account has been updated and you can
        start using your plan or downloads right away.
      </p>
      <button
        className="btn btn-dark"
        type="button"
        onClick={() => history.push('/')}
      >
        Continue browsing
      </button>
    </div>
  );
};

export default Plansuccess;
